import styled from 'styled-components';

export const UserInputCtr = styled.div`
    position:relative;
    width: 90%;
    height: 40px;
    margin: 0 auto;
    margin-bottom: 8px;
    cursor: pointer;
    font-size:16px;
    display: flex;
`;

export const InputSvgCtr = styled.div`
    position: relative;
    width: 14%;
    height: 100%;
    float: ${props=>props.theme.rtl?'right':'left'};
    background-repeat: no-repeat;
    background-position: center;
    background-size: 30%;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13.886' height='16' viewBox='0 0 13.886 16'%3E%3Cpath id='Path_3195' data-name='Path 3195' d='M375.529,765.653l.023.087h-.009a4.578,4.578,0,0,1,.009,1.275,6.8,6.8,0,0,1-.225,1.082,2.354,2.354,0,0,1-.7,2.793l-.018.023-.009,0h0l-.018.009a2.959,2.959,0,0,0-.261.564,3.889,3.889,0,0,1-1.036,1.651.338.338,0,0,0,.11.215v.019a.683.683,0,0,0,.376.156,5.062,5.062,0,0,1,2.839,1.284,3.462,3.462,0,0,1,1.1,2.573h0a.615.615,0,1,1-1.229,0,2.267,2.267,0,0,0-.706-1.683,3.687,3.687,0,0,0-2.1-.94,1.877,1.877,0,0,1-1.142-.523h0a1.633,1.633,0,0,1-.477-1.151v-.257a.619.619,0,0,1,.33-.541,2.7,2.7,0,0,0,.8-1.261,2.718,2.718,0,0,1,.583-1.009h0l.009-.014.028-.023a2.088,2.088,0,0,0,.468-.693.6.6,0,0,0-.041-.624l-.014-.023H374.2a.853.853,0,0,1-.119-.693h0a6.224,6.224,0,0,0,.252-1.1,3.549,3.549,0,0,0,0-.936h0a3.534,3.534,0,0,0-.725-1.477c-.216-.239-.44-.417-.628-.381a1.127,1.127,0,0,1-.619-.092,1.083,1.083,0,0,1-.463-.413.986.986,0,0,0-.61-.271,6.345,6.345,0,0,0-1.078-.055,3.346,3.346,0,0,0-1.853.5,2.545,2.545,0,0,0-.981,1.371h0a4.551,4.551,0,0,0-.252,1.545,3.3,3.3,0,0,0,.261,1.33.971.971,0,0,1,.046.247.667.667,0,0,1-.161.44v0h0l-.018.019a.635.635,0,0,0-.027.605v-.019a2.223,2.223,0,0,0,.482.725h.009l.05.051a2.612,2.612,0,0,1,.541.981,2.608,2.608,0,0,0,.867,1.307.606.606,0,0,1,.3.523h0v.23a1.609,1.609,0,0,1-.477,1.151,1.888,1.888,0,0,1-1.137.523,3.614,3.614,0,0,0-2.091.94,2.223,2.223,0,0,0-.715,1.683.62.62,0,0,1-.624.615.611.611,0,0,1-.61-.615,3.476,3.476,0,0,1,1.091-2.573,5.1,5.1,0,0,1,2.848-1.284.594.594,0,0,0,.367-.165.325.325,0,0,0,.105-.188,3.925,3.925,0,0,1-1.059-1.687,3.677,3.677,0,0,0-.252-.555l-.014-.009h0l-.009-.009a2.375,2.375,0,0,1-.761-2.752,4.649,4.649,0,0,1-.238-1.5,5.88,5.88,0,0,1,.307-1.958,3.7,3.7,0,0,1,1.472-1.99,4.6,4.6,0,0,1,2.509-.711,6.861,6.861,0,0,1,1.321.073,2.12,2.12,0,0,1,1.371.756,1.957,1.957,0,0,1,1.656.825,4.164,4.164,0,0,1,.555.821A2.461,2.461,0,0,1,375.529,765.653Z' transform='translate(-363.821 -762.003)' fill='%23484848'/%3E%3C/svg%3E");
    &.langloc{
        background-image: url("data:image/svg+xml,%3Csvg id='Group_591' data-name='Group 591' xmlns='http://www.w3.org/2000/svg' width='26.281' height='25.354' viewBox='0 0 26.281 25.354'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: %234d4d4d; %7D %3C/style%3E%3C/defs%3E%3Cg id='Group_574' data-name='Group 574' transform='translate(0 7.266)'%3E%3Cpath id='Path_718' data-name='Path 718' class='cls-1' d='M2.937,22.788H2.628a.85.85,0,0,1-.464-.773V19.077H1.855A1.88,1.88,0,0,1,0,17.222V5.937A1.219,1.219,0,0,1,1.237,4.7h13.3a1.33,1.33,0,0,1,1.237,1.237V17.222a1.786,1.786,0,0,1-1.855,1.855h-6.8L3.556,22.633A.929.929,0,0,1,2.937,22.788ZM1.7,6.246V17.068a.333.333,0,0,0,.309.309H3.092a.73.73,0,0,1,.773.773V20l2.319-2.319a.8.8,0,0,1,.618-.309h7.111a.333.333,0,0,0,.309-.309V6.246H1.7Z' transform='translate(0 -4.7)'/%3E%3C/g%3E%3Cg id='Group_575' data-name='Group 575' transform='translate(10.513)'%3E%3Cpath id='Path_719' data-name='Path 719' class='cls-1' d='M19.631,18.242a1.172,1.172,0,0,1-.618-.309L15.3,14.377H12.984v-1.7h2.783a1.172,1.172,0,0,1,.618.309l2.474,2.474V13.6a.73.73,0,0,1,.773-.773h1.082a.333.333,0,0,0,.309-.309V1.7H8.655V6.493H6.8V1.546C6.8.155,7.573,0,8.346,0H21.177a1.386,1.386,0,0,1,1.391,1.391V12.522a1.786,1.786,0,0,1-1.855,1.855H20.4v2.937a.85.85,0,0,1-.464.773C19.786,18.088,19.786,18.242,19.631,18.242Z' transform='translate(-6.8 0)'/%3E%3C/g%3E%3Cg id='Group_576' data-name='Group 576' transform='translate(5.041 10.358)'%3E%3Cpath id='Path_720' data-name='Path 720' class='cls-1' d='M6.877,7.009c0-.155-.155-.309-.464-.309-.155,0-.309.155-.464.309L3.321,14.121c-.155.155,0,.464.309.618.155.155.464,0,.618-.309l.618-1.546h3.4l.618,1.546c0,.155.309.309.464.309h.155a.8.8,0,0,0,.309-.618ZM5.022,11.956,6.413,8.4,7.8,11.956Z' transform='translate(-3.261 -6.7)'/%3E%3C/g%3E%3Cg id='Group_577' data-name='Group 577' transform='translate(15.305 3.092)'%3E%3Cpath id='Path_721' data-name='Path 721' class='cls-1' d='M11.446,9.575v.309a8.781,8.781,0,0,0,2.164-1.7,11.412,11.412,0,0,0,2.474,1.855h.155c.155,0,.309,0,.309-.155.155-.155,0-.464-.155-.618-.928-.618-1.7-1.237-2.319-1.7A6.276,6.276,0,0,0,15.62,4.01h.928a.41.41,0,0,0,.464-.464.41.41,0,0,0-.464-.464H13.919V2.464a.464.464,0,1,0-.928,0v.464H10.364a.41.41,0,0,0-.464.464.41.41,0,0,0,.464.464h4.329A4.811,4.811,0,0,1,13.3,6.792a6.513,6.513,0,0,1-1.082-2.01H11.6a7.72,7.72,0,0,0,1.391,2.783,16.43,16.43,0,0,1-1.7,1.391C11.446,9.111,11.446,9.266,11.446,9.575Z' transform='translate(-9.9 -2)'/%3E%3C/g%3E%3C/svg%3E%0A");
        background-size: 45%;
    };
    &.phone{
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11.436' height='15.4' viewBox='0 0 11.436 15.4'%3E%3Cpath id='Path_3196' data-name='Path 3196' d='M80.885,350.354H91.133a.591.591,0,0,1,.59.59V365.16a.591.591,0,0,1-.59.594H80.885a.6.6,0,0,1-.6-.594V350.944a.6.6,0,0,1,.6-.59Zm3.133,13.218h3.973a.357.357,0,1,0,0-.714H84.019a.357.357,0,1,0,0,.714Zm6.525-12.038H81.475V364.57h9.069V351.533Z' transform='translate(-80.287 -350.354)' fill='%234d4d4d'/%3E%3C/svg%3E");
    };
    
    &.email{
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11.436' height='15.4' viewBox='0 0 11.436 15.4'%3E%3Cpath id='Path_3196' data-name='Path 3196' d='M80.885,350.354H91.133a.591.591,0,0,1,.59.59V365.16a.591.591,0,0,1-.59.594H80.885a.6.6,0,0,1-.6-.594V350.944a.6.6,0,0,1,.6-.59Zm3.133,13.218h3.973a.357.357,0,1,0,0-.714H84.019a.357.357,0,1,0,0,.714Zm6.525-12.038H81.475V364.57h9.069V351.533Z' transform='translate(-80.287 -350.354)' fill='%234d4d4d'/%3E%3C/svg%3E");
    };
    
    &.email{
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11.436' height='15.4' viewBox='0 0 11.436 15.4'%3E%3Cpath id='Path_3196' data-name='Path 3196' d='M80.885,350.354H91.133a.591.591,0,0,1,.59.59V365.16a.591.591,0,0,1-.59.594H80.885a.6.6,0,0,1-.6-.594V350.944a.6.6,0,0,1,.6-.59Zm3.133,13.218h3.973a.357.357,0,1,0,0-.714H84.019a.357.357,0,1,0,0,.714Zm6.525-12.038H81.475V364.57h9.069V351.533Z' transform='translate(-80.287 -350.354)' fill='%234d4d4d'/%3E%3C/svg%3E");
    };
    
`;

export const FieldTitleCtr = styled.div`
    position: relative;
    width: 85%;
    height: 100%;
    float: left;
     ${props=>props.theme.rtl?'border-right':'border-left'}: 1px solid #4a4a4a;
    text-align: ${props=>props.theme.rtl?'right':'left'};
    line-height: 40px;
    ${props=>props.theme.rtl?'padding-right':'padding-left'}:10px;
    &:hover{
        font-weight:500;
         ${props=>props.theme.rtl?'border-right':'border-left'}: 1px solid #76D6E8;        
    }
`;

export const InputFieldCtr = styled.input`
    position: relative;
    width: 85%;
    height: 100%;
    float: left;
    text-align: right;
    background:none;
    outline:none;
    border:none;
    border-bottom: 3px solid #76D6E8;
    font-size: 16px;
    padding-top: 10px;
    color: #76D6E8;
    direction: rtl;
    &.email{
        direction: ltr;
        text-align: left;
    };
    &.phone{
        direction: ltr;
        text-align: left;
    }
`;

export const phoneWrapper = styled.div`
width: 85%;
display: inline-flex;
.phone {
    width: calc(85% - 43px);
}
.phone-container {  
    border-bottom: 3px solid #76D6E8;
    div[class*='filter'] {
        height: 31px;
        border: none;
    }
}
`
export const countryImage = styled.div`
    height: 25px;
    margin-top: 10px;
    position: absolute;
    inset-inline-end: 0;
    img {
        border-radius: 50%;
        width: 21px;
        height: 21px;
        box-shadow: 0px 3px 6px #00000029;
        border: 0.5px solid;
    }
`